import { render, staticRenderFns } from "./DefaultRoute.vue?vue&type=template&id=b301a3c8"
import script from "./DefaultRoute.vue?vue&type=script&lang=js"
export * from "./DefaultRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports